<template>
  <div>
    <borFrame :title="'重点舆情TOP10'">
      <div class="borFrame_content" v-for="(item, index) in list" :key="index">
        <div class="borFrame_content_box">
          <van-tag :color="'#eb6863'" class="borFrame_content_box_tag">{{ item.characteristic ? item.characteristic : '无害'
          }}</van-tag> <span class="borFrame_content_box_title">{{ item.title }}
          </span>
        </div>
        <p class="borFrame_content_more" v-html="item.content">
        </p>
        <div class="borFrame_content_btm">
          <van-tag class="borFrame_content_box_tag" v-for="(item, index) in item.keywords" :key="index">{{
            item }}</van-tag>
        </div>
        <div class="borFrame_content_sub">
          <div class="borFrame_content_sub_left"><i class="iconfont icon-lianjie borFrame_content_sub_icon" />{{
            item.source }}{{ item.userName ? '·' +
    item.userName : '' }}</div>
          <div><i class="iconfont icon-shijian borFrame_content_sub_icon" />
            {{ moment(item.issueTime).format('YYYY-MM-DD HH:mm:ss') }}
          </div>
        </div>
      </div>
      <div class="borFrame_content_btn" @click="detailsClick">
        查看详情 >
      </div>
    </borFrame>
  </div>
</template>
<script>
import borFrame from "@/components/frame";
import moment from 'moment';
import { warningTop10 } from '@/api/index'
export default {
  name: 'Push',
  components: {
    borFrame,
  },
  data() {
    return {
      tabShow: true,
      list: [],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    moment,
    handleClick() {
      this.tabShow = !this.tabShow
    },
    detailsClick() {
      this.$router.push({
        path: '/details',
        query: {
          time: this.$route.query.time
        }
      })
    },
    getList() {
      const time = this.$route.query.time;
      // time格式为2024年3月22日 将time格式化为2024-03-22
      const formatTime = moment(time, 'YYYY年M月D日').format('YYYY-MM-DD');
      //获取formatTime的开始时间和结束时间时间戳
      const startTime = moment(formatTime).startOf('day').valueOf();
      const endTime = moment(formatTime).endOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      console.log(data);
      warningTop10(data).then(res => {
        this.list = res
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.borFrame_content {
  /* 文字内容之间的间距 */
  letter-spacing: 1px;
  line-height: 1.5;
  width: 100%;
  margin-top: .1rem;

  &_box {
    width: 100%;
    display: flex;

    &_tag {
      margin-right: .1rem;
      // 边框阴影
      box-shadow: 0 0 0 1px #ccc;
    }

    &_title {
      // 文字溢出显示...
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 80%;
      display: inline-block;
    }
  }

  &_more {
    background: #f8f8f8;
    letter-spacing: 1px;
    line-height: 1.5;
    margin-top: .1rem;
    // 文字超过三行溢出显示...
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &_btm {
    margin-top: .05rem;
    display: flex;
    flex-wrap: wrap;
  }

  &_sub {
    margin-top: .1rem;
    display: flex;
    justify-content: space-between;

    &_left {
      width: 45%;
      // 文字溢出显示...
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &_icon {
      color: #9a9494;
      margin-right: .05rem;
    }
  }
}

.borFrame_content_btn {
  width: 100%;
  margin-top: .1rem;
  color: #9a9494;
  font-size: .14rem;
  text-align: right;
}
</style>